import {
  IsNotEmpty,
  IsUUID,
  IsArray,
  IsOptional,
  IsInt,
  IsString,
  Min,
} from 'class-validator';
import { Type } from 'class-transformer';

export class GetEventBatchPositionsDto {
  @IsUUID()
  @IsNotEmpty()
  eventTypeId: string;

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  unitIds?: string[];

  @IsUUID()
  @IsOptional()
  parentEventId?: string;

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  names?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @Min(0)
  @Type(() => Number)
  @IsInt()
  @IsOptional()
  offset?: number;

  @Min(1)
  @Type(() => Number)
  @IsInt()
  @IsOptional()
  limit?: number;
}
